'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'backpack';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f5d4';
var svgPathData = 'M320 80h-8V56c0-30.88-25.12-56-56-56h-64c-30.88 0-56 25.12-56 56v24h-8C57.31 80 0 137.31 0 208v240c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V208c0-70.69-57.31-128-128-128zM184 56c0-4.41 3.59-8 8-8h64c4.41 0 8 3.59 8 8v24h-80V56zm136 408H128v-64h192v64zm0-112H128v-32c0-17.67 14.33-32 32-32h128c17.67 0 32 14.33 32 32v32zm80 96c0 8.82-7.18 16-16 16h-16V320c0-44.11-35.89-80-80-80H160c-44.11 0-80 35.89-80 80v144H64c-8.82 0-16-7.18-16-16V208c0-44.11 35.89-80 80-80h192c44.11 0 80 35.89 80 80v240zm-96-288H144c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faBackpack = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;